export default __webpack_public_path__ + "static/victor arias-19243cd4673d6ee4cb3c48789b985f9a.png";